module.exports = __webpack_public_path__ + "img/cmc.08c498f9.png";